import { render } from "./DefaultListSectionV2Cmp.vue?vue&type=template&id=2abb11e6"
import script from "./DefaultListSectionV2Cmp.vue?vue&type=script&lang=js"
export * from "./DefaultListSectionV2Cmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__